<aside class="card enq-form">
  <div class="card-header text-white" style=" background: #006f6f !important;">
    Enquire Now <span class="close d-block d-sm-none d-none d-sm-block d-md-none">×</span>
  </div>

  <form class="card-body" [formGroup]="createForm">
    <div id="contact_form" class="contact-form">
      <!-- <div class="loader_formhideContent" id="lfpqc">
                  <img id="imgWaitClose4" class="loaderImgResize" src="/Projects/images/Loading.svg"
                    alt="Please wait..." loading="lazy">
                </div> -->
      <div class="form-group mt-2">
        <input type="text" id="txtname" name="n" formControlName="name" placeholder="Name *" class="form-control">
        <span id="spname"></span>
        @if(isDataSubmitted && f.name?.errors){
        <span class="text-danger">*Name is required.</span>
        }
      </div>
      <div class="form-group mt-2">

        <input id="txtemail" type="email" name="e" formControlName="email" placeholder="Email Id *"
          class="form-control">

        @if(isDataSubmitted && f.email?.errors){
        <span class="text-danger">*Email is required.</span>
        }
      </div>
      <div class="form-group mt-2">
        <ng-select [items]="utils.countries" bindLabel="dialCode" bindValue="dialCode" formControlName="code"
          placeholder="Code" class="country-code-select"
          [ngClass]="{ 'is-invalid': createForm.get('code').invalid && createForm.get('code').touched }">
          <!-- Custom Label with Flag -->
          <ng-template ng-label-tmp let-item="item">
            <small>
              <small class="flag-icon" [ngClass]="'flag-icon-' + item?.code?.toLowerCase()"></small>
              {{ item.dialCode }}
            </small>
          </ng-template>

          <!-- Custom Dropdown Option -->
          <ng-template ng-option-tmp let-item="item">
            <small>
              <small class="flag-icon" [ngClass]="'flag-icon-' + item?.code?.toLowerCase()"></small>
              <small> {{ item.dialCode }} ({{ item.name }})</small>
            </small>
          </ng-template>
        </ng-select>
      </div>

      <div class="form-group mt-2">
        <input type="text" class="form-control" formControlName="phoneNumber" placeholder="Enter phone number"
          (input)="formatPhoneNumber()"
          [ngClass]="{ 'is-invalid': createForm.get('phoneNumber')?.invalid && (createForm.get('phoneNumber')?.touched || isDataSubmitted) }" />

        <!-- Validation Messages -->
        @if(createForm.get('code')?.invalid && (createForm.get('code')?.touched ||
        isDataSubmitted)){
        <div class="text-danger">
          Country code is required.
        </div>
        }
        @if(createForm.get('phoneNumber')?.invalid && (createForm.get('phoneNumber')?.touched ||
        isDataSubmitted)){
        @if(createForm.get('phoneNumber')?.errors?.required){
        <div class="text-danger">Phone number is required.</div>
        }
        @if(createForm.get('phoneNumber')?.errors?.invalidPhone){
        <div class="text-danger">Please enter a valid phone number for the selected country.</div>
        }
        }

      </div>
      <div class="form-group mt-2">

        <select name="ddlQueryType" id="ddlQueryType" formControlName="userType" class="form-control"
          aria-label="Query Type">
          <option value="" selected>Select User
            Type
          </option>

          <option value="Individual">Individual</option>
          <option value="Agent">Agent</option>
          <option value="Investor">Investor</option>
          <option value="Do not want to disclose">Do not want to disclose</option>


        </select>

        @if(isDataSubmitted && f.userType?.errors){
        <span class="text-danger">*User type is required.</span>
        }
      </div>
      <div class="form-group mt-2">

        <textarea id="txtmsg" placeholder="Enter Message" formControlName="message" class="form-control"></textarea>
        @if(isDataSubmitted && f.message?.errors){
        <span class="text-danger">*Message is required.</span>
        }
      </div>
      <div class="form-group mt-2">
        <button id="tempsubmits" type="button" class="btn btn-block btn_custom btn-rounded d-block"
          (click)="createContact()">
          Send Message</button>
        <button id="submits" type="button" class="btn btn-block btn_custom btn-rounded d-none"
          (click)="createContact()">
          Send Message</button>
      </div>
      <div>
      </div>
      <div class="clear"></div>
      <div class="commission">
        <ul>
          <!-- <li>
                      <i class="fa fa-phone"></i><a href="tel:+971 4 248 3400"
                        title="Call Us">+447424975205</a>
                    </li> -->
          <li class="w-100">
            <div style="display: flex; justify-content: space-around; align-items: center;">
              <div>
                <i class="ri-whatsapp-fill"></i>
                <a rel="nofollow"
                  href="https://api.whatsapp.com/send?l=en&amp;phone=+447424975205&amp;text=I want more information regarding your all projects"
                  target="_blank">Contact Whatsapp</a>
              </div>

              <!-- <div>
                        <i class="ri-mail-fill"></i>
                        <a href="mailto:info@eplogoffplan.com">info&#64;eplogoffplan.com</a>
                       </div> -->
            </div>
          </li>

          <!-- <li><i class="fa fa-whatsapp"></i>
                      <a rel="nofollow"
                        href="https://api.whatsapp.com/send?l=en&amp;phone=+447424975205"
                        target="_blank">+447424975205</a>
                    </li> -->
          <!-- <li>

                  </li> -->
        </ul>

        <div class="clearfix"></div>
      </div>
    </div>
    <div class="card-footer text-center">
      <p class="text">Direct Sales &amp; 0% Commission</p>
    </div>
    <!-- <div class="mortgage d-none d-md-block d-lg-block d-xl-block">

                <a href="/Projects/MAK-Isola-Bella-Mortgage" class="mt-2">
                  <i class="fa fa-calculator" aria-hidden="true"></i>Check Mortgage
                </a>
              </div> -->

  </form>
</aside>